import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Popstart = () => {
    return (
        <Container>
            <Row
                className="justify-content-center"
                style={{ paddingTop: "50px" }}
            >
                <Col xs="auto" className="titles">
                    Ahora ser Popstart tiene sus beneficios
                </Col>
            </Row>
        </Container>
    );
};

export default Popstart;
